import Store from 'store/store';

Store.on('ASPECT_RATIO_TRAILER_SCROLLED', (bool) => {
	Store.get().aspectRatioTrailer.set({ scrolled: bool });
	Store.get().header.set({ aspectRatioTrailerScrolled: bool });
});

Store.on('ASPECT_RATIO_TRAILER_FULLSCREEN', (bool) => {
	Store.get().header.set({ aspectRatioTrailerFullscreen: bool });
});